import { useMemo } from "react";
import { bindActionCreators } from "redux";
import "../../../../features/config/middleware.js";
import { configSlice, configActions } from "../../../../features/config/reducer.js";
import "../../../../features/forms/middleware.js";
import { formsSlice, formsActions } from "../../../../features/forms/reducer.js";
import "../../../../features/forms/selectors.js";
import "../../../../features/stages/middleware.js";
import { stagesSlice, stagesActions } from "../../../../features/stages/reducer.js";
import "../../../../features/stages/selectors.js";
import { useAppDispatch } from "./useAppDispatch.js";
const useAppActions = () => {
  const dispatch = useAppDispatch();
  const createAction = (actions) => bindActionCreators(actions, dispatch);
  return useMemo(
    () => ({
      [configSlice.reducerPath]: createAction(configActions),
      [formsSlice.reducerPath]: createAction(formsActions),
      [stagesSlice.reducerPath]: createAction(stagesActions)
    }),
    []
  );
};
export {
  useAppActions
};
